// extracted by mini-css-extract-plugin
export default {"locationBox":"fCbEa","location":"yZ78D","checkbox":"snH_L","disabledText":"xHS2H"};